import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "py-4" }

import Header from "@/components/organisms/common/Header.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { useRouter } from "vue-router";
import { onBeforeMount, ref } from "vue";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import MenuAnchorLinkItem from "@/components/organisms/mypage/MenuAnchorLinkItem.vue";
import MenuLinkGroup from "@/components/organisms/mypage/MenuLinkGroup.vue";
import { educationService } from "@/app/services/EducationService";
import { WorkerTrainingContent } from "@/types/educations/WorkerTrainingContent";
import {
  AnalyzeWorkerTrainingContentEvent,
  eventService
} from "@/app/services/EventService";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const loader = useLoader();
const errorModal = useErrorModal();
const router = useRouter();

const trainings = ref<WorkerTrainingContent[]>([]);

onBeforeMount(async () => {
  await fetchTrainings();
});

async function fetchTrainings() {
  loader.show();
  try {
    const workerTrainingContents = await educationService.fetchWorkerTrainingContents(
      { query: { ordering: "-created_at" } }
    );
    trainings.value = workerTrainingContents.results;
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
}

function onClickBack() {
  router.back();
}

function onClickMenuItem(workerTrainingContentId: number) {
  // イベントログを記録する。非同期で十分なのでawaitしない
  eventService.registerEvent(
    AnalyzeWorkerTrainingContentEvent.group,
    AnalyzeWorkerTrainingContentEvent.types.openTrainingContent,
    undefined,
    JSON.stringify({
      workerTrainingContentId
    })
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      研修\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MenuLinkGroup, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trainings.value, (training) => {
            return (_openBlock(), _createBlock(MenuAnchorLinkItem, {
              key: training.id,
              label: training.title,
              href: training.url,
              onClick: ($event: any) => (onClickMenuItem(training.id))
            }, null, 8, ["label", "href", "onClick"]))
          }), 128))
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})